var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:{
    [_vm.$style.indicator]: true,
    [_vm.$style.indicatorMesh]: _vm.type === _vm.TagType.Keyword
  }},[(_vm.type === _vm.TagType.Keyword)?[_vm._v(" [MeSH] ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }